import { inject, Injectable } from '@angular/core';
import { MapDataState } from '@ui/shared/domain-map';
import type { SchoolMapItem } from '../definitions/school-map-item';
import { SchoolMapMapDataService } from './school-map-map-data';
import { Result } from '@team23/ts-result';
import { ApiDataStatus } from '@ui/shared/util-api';
import { FilterModel } from '@ui/shared/util-filter';
import { Observable } from 'rxjs';
import { filterKeys } from '../definitions/filter-keys';
import { StudentGuideFilterOption } from '../definitions/student-guide-filter-option';

@Injectable({ providedIn: 'root' })
export class SchoolMapDataStateService extends MapDataState<SchoolMapItem> {
    private readonly _mapDataService = inject(SchoolMapMapDataService);

    public override items$({ filters }: {
        filters: Map<string, FilterModel>;
    }): Observable<Result<Array<SchoolMapItem>, ApiDataStatus>> {
        return this._mapDataService.getMapItems$({
            titleContains: filters.get(filterKeys.textSearch)?.values[0]?.value ?? '',
            typeIds: filters.get(filterKeys.types)?.values.map(value => value.value as number)
                ?? [],
            educationalBranchIds: filters.get(filterKeys.educationalBranches)?.values.map(value => value.value as number)
                ?? [],
            careServiceIds: filters.get(filterKeys.careServices)?.values.map(value => value.value as number)
                ?? [],
            showStudentGuides: filters.get(filterKeys.studentGuides)?.values[0]?.value
                === StudentGuideFilterOption.Yes,
            measureTypeIds: filters.get(filterKeys.measureTypes)?.values.map(value => value.value as number)
                ?? [],
            measureStatuses: filters.get(filterKeys.measureStatus)?.values.map(value => value.value as string)
                ?? [],
        });
    }

    /**
     * Reload failed map data
     */
    public override reloadMapItems(): void {
        this._mapDataService.reloadMapItems();
    }
}
